import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import ScheduleIcon from '@material-ui/icons/Schedule';
import {ORDER_URGENCY, ORDER_URGENCY_COLORS, ORDER_URGENCY_LABELS} from '../global/orderUrgency';

const ICONS = {
    [ORDER_URGENCY.NEXT_DAY]: FlightTakeoffIcon,
    [ORDER_URGENCY.AGED]: ScheduleIcon
};

/**
 * The per-row urgency glyph in the Orders list (#331): a distinct icon and
 * colour per state, with the reason as a tooltip and accessible label, so the
 * two states are told apart by shape as well as hue.
 *
 * @param {string|null} urgency an ORDER_URGENCY value, or null for nothing
 * @return {JSX.Element|null}
 */
const OrderUrgencyIndicator = ({urgency}) => {
    const Icon = (urgency) ? ICONS[urgency] : null;
    if (!Icon) {
        return null;
    }
    const label = ORDER_URGENCY_LABELS[urgency];
    return (
        <Tooltip title={label} placement="right">
            <Icon role="img" aria-label={label}
                  style={{color: ORDER_URGENCY_COLORS[urgency], fontSize: 24, verticalAlign: 'middle'}}/>
        </Tooltip>
    );
};

OrderUrgencyIndicator.propTypes = {
    urgency: PropTypes.string
};

export default OrderUrgencyIndicator;
